import React from "react";
interface FleetrifyCardProps {
  cardContainerClass?: string;
  children?: React.ReactNode;
}

const FleetrifyCard = ({
  cardContainerClass,
  children,
}: FleetrifyCardProps) => {
  return (
    <div
      className={`bg-[#FFFFFF] hide-scrollbar border  w-full rounded-[16px] h-auto overflow-auto min-h-full p-[20px] ${cardContainerClass} flex flex-col`}
    >
      {children}
    </div>
  );
};
export default FleetrifyCard;
